/**
 * @module
 *
 * @import {Amateur} from '../model/amateur';
 * @import {CreatorNodeConfig} from 'acng/ts/amateurPool/template';
 * @import {ElementLinkCallback} from '@acng/frontend-stargazer';
 */

import {LocalActor} from '@acng/frontend-relativity';
import {ctxAmateur} from '../context/amateur.js';
import {get} from './cache.js';
import {NodeUpgrade} from '@acng/frontend-stargazer';
import {user} from '../../user/user.js';
import {zipFilter} from 'acng/core/filter/zip.js';

const provideAmateur = LocalActor(ctxAmateur);

/**
 * @param {Amateur} amateur
 * @param {ImageFormat} [imageFormat]
 *
 * @returns {CreatorNodeConfig}
 */
export const CreatorTemplateConfig = (amateur, imageFormat = '800') => ({
  amateur,
  name: amateur.getNickname(),
  nickname: amateur.getNickname(),
  age: amateur.age,
  address:
    user.international ?
      null
    : {
        addressCountry: amateur.country,
        postalCode: zipFilter(amateur.zip_area, amateur.country),
      },
  description: amateur.getDescription() ?? '',
  image: amateur.getImageUrl(imageFormat),
  url: amateur.url,
  from: (node) => {
    node.textContent = '';
    amateur.getLocation().then((loc) => (node.textContent = loc));
  },
});

/**
 * @param {Amateur} amateur
 * @param {Awaited<ReturnType<typeof CreatorTemplateConfig>>} config
 *
 * @returns {ElementLinkCallback<HTMLElement>}
 */
export const AmateurUpgrade = (amateur, config) => (target, linker) => {
  NodeUpgrade(linker, config);
  provideAmateur(target, amateur);
};

/**
 * @param {Amateur['id']} amateurId
 *
 * @returns {Promise<ElementLinkCallback<HTMLElement>>}
 */
export const ListItem = async (amateurId) => {
  const amateur = await get(amateurId);
  const config = CreatorTemplateConfig(amateur);

  return AmateurUpgrade(amateur, config);
};
